import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PageEditLocation implements ClientPage {

  private countrySelect: HTMLSelectElement | null = null
  private stateSelect: HTMLSelectElement | null = null
  private wasUsaBefore: boolean = false

  getPageId = (): string => "edit-location"

  execute = (): void => {
    this.countrySelect = document.querySelector('select[name="country"]') as HTMLSelectElement
    this.stateSelect = document.querySelector('select[name="state"]') as HTMLSelectElement
    this.wasUsaBefore = this.countrySelect?.value === "US"

    this.setupSelectStateElement()

    this.countrySelect?.addEventListener("change", () => {
      this.setupSelectStateElement()
    })
  }

  setupSelectStateElement = (): void => {
    const selectedCountryCode = this.countrySelect?.value
    const isUsaNow = selectedCountryCode === "US"

    if (isUsaNow) {
      if (!this.wasUsaBefore) {
        // Deselect state
        this.stateSelect.value = ""
        const event = new Event('change', { bubbles: true });
        this.stateSelect.dispatchEvent(event);
      }
      this.stateSelect?.parentElement?.classList?.remove("d-none")
    } else {
      // Hide and mark as not required
      this.stateSelect?.parentElement?.classList?.add("d-none")
      this.stateSelect.value = "WY" // Select any valid option, it won't get saved anyway
    }

    this.wasUsaBefore = isUsaNow
  }

  onPageClose = (): void => {}
}
